import React, { useEffect, useState, KeyboardEvent } from 'react';
import MuiTable from '../../components/MuiTable/MuiTable';
import Button from '../../components/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import SearchInput from '../../components/SearchInput/SearchInput';
import PageHeading from '../../components/PageHeading/PageHeading';
import { useNavigate } from 'react-router-dom';
import InputForm from '../../components/InputForm/InputForm';
import MultipleFilter from '../../components/MultipleFilter/MultipleFilter';
import axiosInstance from '../../service/axiosInstane';
import { errorMessage } from '../../config/errorsMsg';
import { flashBarTheme } from '../../config/flashBar';
import Input from '../../components/Input/Input';
import Dropdown from '../../components/Dropdown/Dropdown';
import { Role, RoleMapping, SortOrderType } from '../../config/enum';
import { StateProps } from '../../redux/reducer';
import qs from 'qs';
import { errorMessageAutoCapitalize, totalPages } from '../../config/helpers';
import { keyword, successMessage } from '../../config/keyword';

type AddUserProps = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  role: number;
  organizationId: string | number | undefined | null;
  organizationRoleId: string | null;
};

type RequestProps = {
  page: number;
  pageSize: number;
  searchText: string;
  organizationFilter: string[];
  filterRoles: number[];
  sortBy: string;
  sortOrder: string;
};

type ResultProps = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: number;
};

type ResponseProps = {
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  results: ResultProps[];
};

type OrgRoleProps = {
  role: string;
  organization: string;
  organizationId: string;
  id: string;
};

type FilterProps = {
  type?: string;
  selectedMenu?: any;
};

const columns = [
  {
    id: 'firstName',
    label: 'First Name',
    minWidth: 120,
    align: 'left',
  },
  {
    id: 'lastName',
    label: 'Last Name',
    minWidth: 120,
    align: 'left',
  },
  {
    id: 'role',
    label: 'Type',
    minWidth: 100,
    align: 'left',
  },
  {
    id: 'organizationRoleName',
    label: 'Role',
    minWidth: 220,
    align: 'left',
  },
  {
    id: 'email',
    label: 'Email',
    minWidth: 120,
    align: 'left',
  },
  {
    id: 'action',
    label: 'Action',
    minWidth: 0,
    align: 'right',
  },
];
const applicationRoleOptions = [
  { name: 'Super Admin', id: Role.SuperAdmin },
  { name: 'Admin', id: Role.Admin },
  { name: 'User', id: Role.User },
];
const applicationRoles = [
  { name: 'Super Admin', id: '1' },
  { name: 'Admin', id: '2' },
  { name: 'User', id: '3' },
];
const Users = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);

  const filteredOptions = applicationRoleOptions.filter((option) => {
    if (userInfo.role === Role.Admin) {
      return option.id !== Role.SuperAdmin;
    }
    return true;
  });
  const breadcrumb = [{ path: '/users', name: 'User' }];
  const [formError, setFormError] = useState<any>({});
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [state, setState] = useState<AddUserProps>({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    role: 0,
    organizationId: userInfo.role === Role.Admin ? userInfo.organizationId : null,
    organizationRoleId: null,
  });
  const {
    firstName,
    lastName,
    email,
    password,
    role,
    organizationId,
    organizationRoleId,
  } = state;
  const [userState, setUseState] = useState<ResultProps[]>([]);
  const [organizations, setOrganizations] = useState([
    {
      id: '',
      name: '',
    },
  ]);
  const [organizationRole, setOrganizationsRole] = useState([
    {
      id: '',
      name: '',
    },
  ]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [requestState, setRequestState] = useState<RequestProps>({
    page: page,
    pageSize: limit,
    searchText: '',
    organizationFilter: [],
    filterRoles: [],
    sortBy: '',
    sortOrder: SortOrderType.ASC,
  });

  const rootFilter = [
    {
      Heading: keyword.APPLICATION_ROLE,
      data:
        userInfo.role === Role.SuperAdmin
          ? applicationRoles
          : applicationRoles.filter((item) => item.id !== '1'),
    },
    {
      Heading: keyword.ORGANIZATION,
      data: organizations.filter((item) => item.name !== 'code'),
    },
  ];

  useEffect(() => {
    dispatch(update_breadcrumb(breadcrumb));
    getUsers(requestState);

    if (userInfo.role === Role.SuperAdmin) {
      getAllOrganization();
    }
    if (userInfo.role === Role.Admin) {
      getOrganizationRole();
    }
  }, []);

  useEffect(() => {
    if (Object.keys(formError).length === 0 && isSubmit) {
      addUser();
    }
  }, [formError]);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    if (event.target.name === 'email' || event.target.name === 'password') {
      const format = /^\S*$/;

      format.test(event.target.value) &&
        setState({
          ...state,
          [event.target.name]: event.target.value,
        });
    } else {
      setState({
        ...state,
        [event.target.name]: event.target.value,
      });
    }
    if (event.target.value !== '' || Number(event.target.value) !== 0) {
      setFormError({ ...formError, [event.target.name]: undefined });
    } else {
      setFormError({
        ...formError,
        [event.target.name]: `${errorMessageAutoCapitalize(
          event.target.name
        )} is required`,
      });
    }
  };

  const gotResponse = (data: ResponseProps) => {
    if (data.results === null) {
      setUseState([]);
    } else {
      setUseState(data.results as ResultProps[]);
      setTotalRowCount(data.totalCount);
    }
    dispatch(updateIsLoading(false));
  };

  const validation = () => {
    const error: any = {};

    if (!firstName) {
      error.firstName = errorMessage.emptyFirstName;
    } else if (
      (firstName.length > 0 && firstName.length < 2) ||
      firstName.length > 64
    ) {
      error.firstName = errorMessage.userFirstNameLength;
    }
    if (!lastName) {
      error.lastName = errorMessage.emptyLastName;
    } else if (
      (lastName.length > 0 && lastName.length < 2) ||
      lastName.length > 64
    ) {
      error.lastName = errorMessage.userLastNameLength;
    }
    if (!email) {
      error.email = errorMessage.emptyEmail;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      error.email = 'Invalid email address';
    }
    if (!password) {
      error.password = errorMessage.emptyPassword;
    } else if (
      (password.length > 0 && password.length < 12) ||
      password.length > 38
    ) {
      error.password = errorMessage.userPasswordLength;
    }
    if (Number(role) === 0) {
      error.role = errorMessage.emptyRole;
    }
    if (
      userInfo.role === Role.SuperAdmin &&
      (Number(role) === 2 || Number(role) === 3)
    ) {
      if (!organizationId) {
        error.organizationId = errorMessage.emptyOrganization;
      }
    }
    if (userInfo.role === Role.Admin && Number(role) === 3) {
      if (!organizationRoleId) {
        error.organizationRoleId = errorMessage.emptyOrganizationRole;
      }
    }

    return error;
  };

  const onCancel = () => {
    setIsFormOpen(false);
    setIsSubmit(false);
    setFormError({});
    setState({
      ...state,
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      role: 0,
      organizationId: '',
      organizationRoleId: null,
    });
  };

  const viewRecord = (row: ResultProps) => {
    navigate(`/userDetails/${row.id}`);
  };

  const onSubmit = () => {
    setFormError(validation());
    setIsSubmit(true);
  };

  const getAllOrganization = () => {
    dispatch(updateIsLoading(true));
    axiosInstance
      .get('/organizations')
      .then((response) => {
        if (response.status === 200) {
          setOrganizations(response.data);
          dispatch(updateIsLoading(false));
        }
      })
      .catch(() => {
        dispatch(updateIsLoading(false));
        const obj = {
          isOpen: true,
          message: 'Something went wrong!',
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const getOrganizationRole = () => {
    dispatch(updateIsLoading(true));
    axiosInstance
      .get(`organizations/${userInfo.organizationId}/roles`)
      .then((response) => {
        if (response.status === 200) {
          setOrganizationsRole(
            response.data.map((item: OrgRoleProps) => {
              return { id: item.id, name: item.role };
            })
          );
          dispatch(updateIsLoading(false));
        }
      })
      .catch(() => {
        dispatch(updateIsLoading(false));
        const obj = {
          isOpen: true,
          message: 'Something went wrong!',
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
      });
  };

  const addUser = async () => {
    const obj = {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      email: email,
      password: password,
      role: Number(role),
      organizationId: organizationId,
      organizationRoleId: organizationRoleId,
    };

    dispatch(updateIsLoading(true));
    await axiosInstance
      .post('/users', obj)
      .then((response) => {
        if (response.status === 201) {
          const obj = {
            isOpen: true,
            message: successMessage.USER_ADD,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          setIsFormOpen(false);
          getUsers({ ...requestState, page: page, pageSize: limit, sortBy: '' });
          setState({
            ...state,
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            role: 0,
            organizationId: '',
            organizationRoleId: null,
          });
          navigate(`/userDetails/${response.data.userID}`);
          dispatch(updateIsLoading(false));
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message || err.response.data.errors.Code[0],
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const getUsers = async (obj: RequestProps) => {
    dispatch(updateIsLoading(true));
    const queryString = qs.stringify(obj, { arrayFormat: 'repeat' });
    const url = `/users?${queryString}`;
    await axiosInstance
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const searchHandler = () => {
    getUsers({
      ...requestState,
      searchText: requestState.searchText,
      pageSize: limit,
      page: 1,
    });
    setPage(1);
  };
  const onSearchHanlder = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setRequestState({ ...requestState, searchText: e.target.value });
  };

  const handleEnterKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      searchHandler();
    }
  };

  const onClearSearch = () => {
    setRequestState({
      ...requestState,
      searchText: '',
      page: page,
      pageSize: limit,
    });
    getUsers({
      ...requestState,
      searchText: '',
      page: page,
      pageSize: limit,
    });
  };
  const sorting = (sortOrder: string) => {
    let temp = '';
    if (sortOrder == SortOrderType.DESC) {
      temp = SortOrderType.ASC;
    } else {
      temp = SortOrderType.DESC;
    }
    setRequestState({ ...requestState, sortOrder: temp });
    return temp;
  };
  const sortRecord = (fieldName: string, sortOrder: string) => {
    getUsers({
      ...requestState,
      sortOrder: sorting(sortOrder),
      sortBy: fieldName,
      page: page,
      pageSize: limit,
      searchText: requestState.searchText,
    });
    setRequestState({
      ...requestState,
      sortBy: fieldName,
      sortOrder: sorting(sortOrder),
    });
  };
  const filterHandler = (arg: FilterProps[]) => {
    const orgArr: string[] = [];
    const appArr: number[] = [];
    for (let i = 0; i < arg.length; i++) {
      if (arg[i]?.type == keyword.APPLICATION_ROLE) {
        appArr.push(arg[i]?.selectedMenu);
      } else {
        orgArr.push(arg[i]?.selectedMenu);
      }
    }
    getUsers({
      ...requestState,
      sortOrder: requestState.sortOrder,
      sortBy: requestState.sortBy,
      page: 1,
      pageSize: limit,
      organizationFilter: orgArr,
      filterRoles: appArr,
    });
    setRequestState({
      ...requestState,
      organizationFilter: orgArr,
      filterRoles: appArr,
    });
    setPage(1);
  };

  const paginateHandler = {
    onClickPageNumber: (page: number) => {
      getUsers({ ...requestState, page: page, pageSize: limit });
      setPage(page);
    },
    onNextClick: () => {
      if (page < totalPages(totalRowCount, limit)) {
        getUsers({
          ...requestState,
          page: page + 1,
          pageSize: limit,
          organizationFilter: requestState.organizationFilter,
          filterRoles: requestState.filterRoles,
        });
        setPage(page + 1);
      }
    },
    onPrevClick: () => {
      if (page > 1) {
        getUsers({
          ...requestState,
          page: page - 1,
          pageSize: limit,
          organizationFilter: requestState.organizationFilter,
          filterRoles: requestState.filterRoles,
        });
        setPage(page - 1);
      }
    },
    onFirstClick: () => {
      if (page !== 1) {
        getUsers({
          ...requestState,
          page: 1,
          pageSize: limit,
          organizationFilter: requestState.organizationFilter,
          filterRoles: requestState.filterRoles,
        });
        setPage(1);
      }
    },
    onLastClick: () => {
      if (page !== totalPages(totalRowCount, limit)) {
        getUsers({
          ...requestState,
          page: totalPages(totalRowCount, limit),
          pageSize: limit,
          organizationFilter: requestState.organizationFilter,
          filterRoles: requestState.filterRoles,
        });
        setPage(totalPages(totalRowCount, limit));
      }
    },

    limitHandler: (item: number) => {
      getUsers({
        ...requestState,
        page: 1,
        pageSize: item,
        organizationFilter: requestState.organizationFilter,
        filterRoles: requestState.filterRoles,
      });
      setLimit(item);
      setPage(1);
    },
  };

  return (
    <>
      <div className="px-2 py-1 ">
        <PageHeading label="Users Management" />
        <div className="bg-white p-2 rounded-sm shadow-lg">
          <div className="xl:flex items-center justify-between xl:space-y-1 transition-all duration-200 ease-in-out">
            <SearchInput
              value={requestState.searchText}
              onChange={onSearchHanlder}
              onSearch={searchHandler}
              onClear={() => onClearSearch()}
              handleEnterKeyPress={handleEnterKeyPress}
            />

            <div className="mt-4">
              <MultipleFilter
                filterHandler={filterHandler}
                rootFilter={
                  userInfo.role === Role.Admin
                    ? rootFilter.filter((item) => item.Heading !== 'Organization')
                    : rootFilter
                }
              />
            </div>

            <div className="mt-4 md:ml-4">
              <Button
                label="Add"
                type="button"
                buttonType="primary"
                icon={<i className="fa-solid fa-plus"></i>}
                onClick={() => setIsFormOpen(!isFormOpen)}
              />
            </div>
          </div>

          <InputForm
            title={'Add New User'}
            isFormOpen={isFormOpen}
            onSubmit={onSubmit}
            onCancel={onCancel}
          >
            <>
              <div className="lg:flex items-center justify-between">
                <Input
                  name={'firstName'}
                  type={'text'}
                  label={'First Name'}
                  value={firstName}
                  placeholder={`Enter First Name`}
                  onChange={handleChange}
                  error={formError?.firstName}
                />

                <Input
                  name={'lastName'}
                  type={'text'}
                  value={lastName}
                  label={'Last Name'}
                  placeholder={`Enter Last Name`}
                  onChange={handleChange}
                  error={formError?.lastName}
                />
              </div>
              <div className="lg:flex items-center sm:justify-between">
                <Input
                  name={'email'}
                  type={'text'}
                  label={'Email'}
                  value={email}
                  placeholder={`Enter Email`}
                  onChange={handleChange}
                  error={formError?.email}
                />
                <Input
                  name={'password'}
                  type={'password'}
                  label={'Password'}
                  value={password}
                  placeholder={`Enter Password`}
                  onChange={handleChange}
                  error={formError?.password}
                />
              </div>
              <div className="lg:flex items-center justify-between">
                <Dropdown
                  label={'Type'}
                  name={'role'}
                  value={role}
                  initialOption={{
                    name: 'Select Type',
                    id: '',
                  }}
                  options={filteredOptions}
                  error={formError?.role}
                  onChange={handleChange}
                />
                {userInfo.role === Role.SuperAdmin &&
                  (Number(role) === Role.Admin || Number(role) === Role.User) && (
                    <Dropdown
                      label={'Organization'}
                      name={'organizationId'}
                      value={organizationId as string}
                      initialOption={{
                        name: 'Select Organization',
                        id: '',
                      }}
                      options={organizations}
                      error={formError?.organizationId}
                      onChange={handleChange}
                    />
                  )}{' '}
                {userInfo.role === Role.Admin && Number(role) === Role.User && (
                  <Dropdown
                    label={'Role'}
                    name={'organizationRoleId'}
                    value={organizationRoleId as string}
                    initialOption={{
                      name: ' Select Role',
                      id: '',
                    }}
                    options={organizationRole}
                    error={formError?.organizationRoleId}
                    onChange={handleChange}
                  />
                )}{' '}
              </div>{' '}
            </>
          </InputForm>

          <div className="mt-2">
            <MuiTable
              columns={columns}
              rows={userState.map((user: ResultProps) => ({
                ...user,
                role: RoleMapping[user.role as Role],
              }))}
              page={page}
              limit={limit}
              paginateHandler={paginateHandler}
              totalRowCount={totalRowCount}
              onSortHandler={sortRecord}
              sortOrder={requestState.sortOrder}
              checkBoxShow={false}
              checkBoxValue={'id'}
              onViewHandler={viewRecord}
              showView={true}
              sortArray={['firstName', 'lastName', 'email']}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Users;
